import { CommonModule, DatePipe } from '@angular/common'
import { Component, Input, OnInit } from '@angular/core'
import { TableModule } from 'primeng/table'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

interface EmailAttachment {
  name: string
  url?: string
  size?: number
  type?: string
}

interface EmailModel {
  id: string | number
  fromEmail: string
  fromName?: string
  recipients: string | string[]
  subject: string
  content: string
  sentDate?: string | Date
  createdAt?: string | Date
  createdAtFormatted?: string
  attachments?: EmailAttachment[]
  isExpanded?: boolean // Pour le suivi de l'état d'expansion
}

@Component({
  selector: 'app-affair-mails',
  templateUrl: './affair-mails.component.html',
  styleUrls: ['./affair-mails.component.scss'],
  standalone: true,
  imports: [CommonModule, TableModule, ProgressSpinnerModule, DatePipe],
})
export class AffairMailsComponent implements OnInit {
  @Input() mails: EmailModel[]
  @Input() mailsLoading: boolean

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {}

  toggleExpand(mail: EmailModel): void {
    mail.isExpanded = !mail.isExpanded
  }

  isExpanded(mail: EmailModel): boolean {
    return mail.isExpanded === true
  }

  formatDate(dateString: string | Date | undefined): string {
    if (!dateString) return ''

    const date = new Date(dateString)
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }

    return new Date(dateString).toLocaleDateString('fr-FR', options)
  }

  formatRecipients(recipients: string | string[]): string {
    if (!recipients) return ''

    if (typeof recipients === 'string') {
      return recipients
    } else {
      return recipients.join(', ')
    }
  }

  sanitizeHtml(html: string): SafeHtml {
    if (!html) return ''
    // Nettoie et sécurise le HTML avant de l'afficher
    return this.sanitizer.bypassSecurityTrustHtml(html)
  }

  trackByIndex(index: number, item: any): number {
    return index
  }
}
